import { Item as ItemModel } from 'models/Recommendation/Item';
import React from 'react';
import { DisplayPrice } from 'shared-client/types/commerce/display-price';
import ProductPricing from 'shared/components/commerce/ProductPricing';

export interface ProductPriceRenderer {
	item: ItemModel;
	classNameSuffix: string;
}

/**
 * Renders pricing for individual recommended product returned from hawk api using custom context.
 */
export function ProductPriceRenderer({ item }: ProductPriceRenderer) {
	const displayPriceStringified =
		item.customDict['product_groupdisplayprice'] || item.customDict['product_displayprice'];

	let displayPrice: DisplayPrice | undefined = undefined;

	try {
		displayPrice = displayPriceStringified ? (JSON.parse(displayPriceStringified) as DisplayPrice) : undefined;
	} catch (error) {
		console.error('Unable to parse product price:', error);
	}

	return <ProductPricing displayPrice={displayPrice} className={'roc-product-list__price'} />;
}
